import { useContext } from "react";
import { AppContext } from "../App";
import personFront from "../assets/engineer1.png";
import personSupport from "../assets/engineer2.png";
import portalSite from "../assets/construction2.png";
import portalTower from "../assets/construction1.png";
import stageBackground from "../assets/construction3.png";

export default function HomeBanner() {
  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({ item });
  }

  return (
    <section
      className="tgm-orion-hero"
      style={{ "--tgm-hero-bg": `url(${stageBackground})` }}
    >
      <div className="container tgm-orion-hero-shell">
        <div className="tgm-orion-copy" data-aos="fade-up">
          <h1 className="tgm-orion-title">
            Building Civil Works With Assured Project Execution
          </h1>

          <p className="tgm-orion-desc font-regular">
            SMART TGM Limited is a Tanzania-registered civil and building
            contractor delivering roads, infrastructure, residential and
            commercial buildings with clear coordination, quality supervision,
            and on-time commissioning.
          </p>

          <div className="tgm-orion-actions">
            <button
              type="button"
              className="tgm-orion-btn tgm-orion-btn-primary font-semi-bold"
              onClick={() => goTo("services")}
            >
              What we do
            </button>
            <button
              type="button"
              className="tgm-orion-btn tgm-orion-btn-outline font-semi-bold"
              onClick={() => goTo("contact_us")}
            >
              Free consultation
            </button>
          </div>
        </div>

        <div className="tgm-orion-visual" aria-hidden="true">
          <div className="tgm-orion-site-flag"></div>
          <img
            className="tgm-orion-person tgm-orion-person-support"
            src={personSupport}
            alt=""
          />
          <img
            className="tgm-orion-person tgm-orion-person-front"
            src={personFront}
            alt=""
          />
        </div>

        <div className="tgm-orion-proof" data-aos="fade-up" data-aos-delay="120">
          <div className="tgm-orion-portals" aria-hidden="true">
            <div className="tgm-orion-portal tgm-orion-portal-front">
              <img src={portalSite} alt="" />
            </div>
            <div className="tgm-orion-portal tgm-orion-portal-back">
              <img src={portalTower} alt="" />
            </div>
          </div>

          <div className="tgm-orion-proof-copy">
            <strong>Shaping Tanzania's built environment</strong>
          </div>

          <div className="tgm-orion-proof-ring" aria-hidden="true"></div>
        </div>
      </div>
    </section>
  );
}
